import * as React from 'react'
function SvgSettings(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M34.27 17.568c-2.606-.652-3.842-3.636-2.46-5.938.644-1.072.45-1.996-.188-2.632l-.62-.62c-.636-.636-1.56-.83-2.632-.188-2.304 1.382-5.288.146-5.938-2.46C22.13 4.516 21.338 4 20.438 4h-.876c-.9 0-1.69.516-1.994 1.73-.652 2.606-3.636 3.842-5.938 2.46-1.072-.644-1.998-.45-2.634.186l-.62.62c-.636.636-.83 1.562-.186 2.634 1.382 2.304.146 5.288-2.46 5.938C4.52 17.87 4 18.66 4 19.562v.876c0 .9.516 1.69 1.73 1.994 2.606.652 3.842 3.636 2.46 5.938-.644 1.072-.45 1.996.188 2.632l.62.62c.638.638 1.564.83 2.632.188 2.304-1.382 5.288-.146 5.938 2.46.302 1.214 1.094 1.73 1.994 1.73h.876c.9 0 1.69-.516 1.994-1.73.652-2.606 3.636-3.842 5.938-2.46 1.07.642 1.994.45 2.632-.188l.62-.62c.636-.636.83-1.56.188-2.632-1.382-2.304-.146-5.288 2.46-5.938 1.214-.302 1.73-1.094 1.73-1.994v-.876c0-.902-.52-1.692-1.73-1.994zM20 26a6 6 0 110-12 6 6 0 010 12z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgSettings
